/**
 * O aviso de sessao expirada.
 *
 * Antes disto o app dizia "pendente" e mostrava dado velho do cache, o que e
 * indistinguivel de estar sem rede — e manda a pessoa procurar problema no
 * lugar errado (o Wi-Fi) enquanto a solucao e entrar de novo.
 *
 * O botao faz uma navegacao de TOPO (`location.reload`), e nao um `fetch`: so
 * uma navegacao completa passa pelo fluxo do Cloudflare Access e volta com o
 * cookie novo. Uma requisicao em segundo plano seria desviada outra vez, em
 * silencio, para sempre.
 */
import { useSyncExternalStore } from 'react';
import { assinarSessao, sessaoExpirada } from '../../lib/sessao.js';

export function SessaoExpirada() {
  const expirada = useSyncExternalStore(assinarSessao, sessaoExpirada, () => false);

  if (!expirada) return null;

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-2 bg-overdue px-4 py-2 text-sm text-white"
    >
      <span>
        Sua sessão expirou. O que você alterou está guardado e será enviado assim que você
        entrar.
      </span>

      <button
        type="button"
        onClick={() => location.reload()}
        className="min-h-touch rounded-sm bg-surface px-3 font-medium text-overdue"
      >
        Entrar de novo
      </button>
    </div>
  );
}
